import { lazy } from 'react';
import withLazy from '~/components/LazySuspense';

export const LazyDeveloperCompany = withLazy(lazy(() => import('~/pages/Developer/Company')));
export const LazyDeveloperGuaritas = withLazy(lazy(() => import('~/pages/Developer/Guaritas')));
export const LazyDeveloperLpr = withLazy(lazy(() => import('~/pages/Developer/Lpr')));
export const LazyDeveloperMaxbot = withLazy(lazy(() => import('~/pages/Developer/Maxbot')));
export const LazyDeveloperUsers = withLazy(lazy(() => import('~/pages/Developer/Users')));
